class DropdownToggle extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    this.handleChange = this.handleChange.bind(this)

    this.listeners.add(this.els.select.element, 'change', this.handleChange)
  }

  handleChange (e) {
    this.els.content.elements.forEach((contentEl) => {
      contentEl.setAttribute(
        'aria-expanded',
        contentEl.dataset.title === e.target.value,
      )
    })
  }
}

if (!customElements.get('dropdown-toggle')) {
  customElements.define('dropdown-toggle', DropdownToggle)
}
